'use client'

import { useTenant } from '@rewardops/auth/src/client'

import { DevAuthButtons } from './dev-auth-buttons'

export function DevTools() {
  const tenant = useTenant()

  if (!tenant || tenant.nodeEnv === 'production') return null

  return (
    <div className="fixed bottom-1 left-1 z-50 flex flex-col">
      <DevAuthButtons />
    </div>
  )
}
